import * as yup from "yup";

export const configuracaoPizzaSchema =  yup.object().shape({
  descricao: yup.string().required("O tamanho é obrigatório"),
  modeloPrecificacao: yup.string().required("O modelo de precificação deve ser preenchido"),
  quantidadeSabores: yup.number().required("Selecione o número de sabores").min(1, "O número mínimo de sabores é 1"),
  quantidadeFatias: yup.number().required("Selecione o número de fatias").min(1, "O número mínimo de fatias é 1"),
  maxAdicionais: yup
    .number()
    .transform((value, original) => (original === '' || original === null || original === undefined ? undefined : value))
    .optional()
    .nullable()
    .min(1, "O máximo de adicionais deve ser pelo menos 1")
    .integer("O máximo de adicionais deve ser um número inteiro"),
  massaObrigatoria: yup.boolean().optional(),
  bordaObrigatoria: yup.boolean().optional(),
});
  